import { createAction } from '@reduxjs/toolkit';
import { contactTypes } from 'types';

export const CONTACTS_SAGA = 'CONTACTS_SAGA';
export const contactsSaga = createAction<contactTypes.IContactForm>(CONTACTS_SAGA);
